/**
 * Converte o ponto de foco (0–100 da imagem) no object-position/background-position (%) que deixa
 * esse ponto no centro do quadro com `cover`, limitado às bordas da imagem.
 * Mesma conta de backend/services/landingSocialCardService.js (focalObjectPosition).
 */
export function focalObjectPosition(
  focusX: number,
  focusY: number,
  imgW: number,
  imgH: number,
  frameW: number,
  frameH: number
): string {
  if (!imgW || !imgH || !frameW || !frameH) return `${focusX}% ${focusY}%`;
  const axis = (f: number, visible: number) => {
    if (!(visible < 1)) return 50;
    const start = Math.min(Math.max(f / 100 - visible / 2, 0), 1 - visible);
    return (start / (1 - visible)) * 100;
  };
  const imgRatio = imgW / imgH;
  const frameRatio = frameW / frameH;
  return `${axis(focusX, frameRatio / imgRatio)}% ${axis(focusY, imgRatio / frameRatio)}%`;
}
